export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const isNonBlankString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export const parseFutureDateTime = (value: unknown, now: Date): Date | null => {
  if (!isNonBlankString(value)) return null;

  const timestamp = Date.parse(value);
  const currentTimestamp = now.getTime();

  if (!Number.isFinite(timestamp) || !Number.isFinite(currentTimestamp) || timestamp <= currentTimestamp) {
    return null;
  }

  return new Date(timestamp);
};
